document.querySelectorAll('[data-choice-guide]').forEach((root) => {
  const form = root.closest('form');
  const section = root.closest('.main-product');
  const select = form?.querySelector('select[name="id"]');
  if (!select) return;
  let config, variants;
  try {
    config = JSON.parse(root.querySelector('[data-choice-config]').textContent);
    variants = JSON.parse(root.querySelector('[data-choice-variants]').textContent);
  } catch { return; }
  const locale = root.dataset.choiceLang;
  const label = (value) => value?.[locale] || value?.en || '';
  const rows = variants.map((v) => ({...v, ...config.variants[v.sku]}));
  // Keep the original selector available if any newly added SKU has no mapping.
  if (rows.some((v) => !v.labels || v.dimensions.length !== config.fields.length)) return;
  const message = {en:'Selected package',de:'Ausgewähltes Paket',fr:'Ensemble sélectionné'}[locale];
  const summary = root.querySelector('[data-choice-summary]');
  const fields = root.querySelector('[data-choice-fields]');
  const controls = [];
  let syncing = false;
  const selectedRow = () => rows.find((v) => String(v.id) === select.value);
  const showSelected = (row) => {
    if (!row) return;
    summary.hidden = false;
    summary.textContent = message + ': ' + label(row.labels) + ' · ' + row.sku;
    const picture = section.querySelector('[data-choice-image]');
    if (picture && row.image) {
      picture.src = row.image;
      picture.removeAttribute('srcset');
      picture.alt = label(row.labels);
      const thumb = section.querySelector('[data-gallery-thumb="choice"]');
      const thumbPicture = thumb?.querySelector('img');
      if (thumbPicture) {
        thumbPicture.src = row.image;
        thumbPicture.removeAttribute('srcset');
        thumbPicture.alt = label(row.labels);
        thumb.setAttribute('aria-label', label(row.labels));
      }
      thumb?.click();
    }
  };
  if (config.fields.length) {
    config.fields.forEach((name, index) => {
      const wrapper = document.createElement('div');
      const text = document.createElement('label');
      const control = document.createElement('select');
      control.id = select.id + '-choice-' + index;
      control.dataset.choiceIndex = index;
      text.htmlFor = control.id;
      text.textContent = (index + 1) + '. ' + label(name);
      wrapper.append(text, control);
      fields.append(wrapper);
      controls.push(control);
    });
    const fill = (desired) => {
      let candidates = rows;
      controls.forEach((control, index) => {
        const values = [...new Set(candidates.map((r) => r.dimensions[index].en))];
        control.replaceChildren(...values.map((value) => {
          const row = candidates.find((r) => r.dimensions[index].en === value);
          return new Option(label(row.dimensions[index]), value);
        }));
        control.value = values.includes(desired[index]) ? desired[index] : values[0];
        candidates = candidates.filter((r) => r.dimensions[index].en === control.value);
      });
      return candidates[0];
    };
    // Ambiguous dimensions must never silently choose an unrelated SKU.
    if (new Set(rows.map((r) => JSON.stringify(r.dimensions.map((d) => d.en)))).size !== rows.length) return;
    controls.forEach((control) => control.addEventListener('change', () => {
      const chosen = fill(controls.map((c) => c.value));
      if (!chosen) return;
      syncing = true;
      select.value = String(chosen.id);
      select.dispatchEvent(new Event('change', {bubbles:true}));
      syncing = false;
      showSelected(chosen);
    }));
    select.addEventListener('change', () => {
      const chosen = selectedRow();
      if (!chosen) return;
      if (!syncing) fill(chosen.dimensions.map((d) => d.en));
      showSelected(chosen);
    });
    const initial = selectedRow() || rows[0];
    fill(initial.dimensions.map((d) => d.en));
    fields.hidden = false;
    select.hidden = true;
    form.querySelector('label[for="' + select.id + '"]')?.setAttribute('hidden','');
    showSelected(initial);
  } else {
    select.addEventListener('change', () => showSelected(selectedRow()));
    showSelected(selectedRow());
  }
});
